export default __webpack_public_path__ + "static/media/guide_046.03441017.md";